module.exports = __webpack_public_path__ + "img/condidature.b759eff4.svg";